import Pager from 'react-pager'
import BaseQueryControlComponent from './BaseQueryControlComponent'
import React from 'react'

class PagerComponent extends BaseQueryControlComponent {

  setPage(page) {
    this.props.page ? this.updateCurrentQuery({
      page: page + 1
    })
    :
    this.updateCurrentQuery({
      receivedPage: page + 1
    })
  }

  render() {
    const page = this.props.page ? this.props.page : this.props.receivedPage;
    if (this.props.total) {
      return <Pager visiblePages={5} current={page - 1}
                    total={Math.ceil(this.props.total / this.props.limit)}
                    onPageChanged={this.setPage.bind(this)}/>
    }
    return <div></div>
  }
}
PagerComponent.displayName = 'PagerComponent';
export default PagerComponent;



// WEBPACK FOOTER //
// ./src/components/common/PagerComponent.js